(function () {
    'use strict';
    /*
     * Copyright (c) 2014-18 In Hand Health.
     * All rights reserved.
     */

    angular
        .module('ihh-common-web')
        .controller('ChangePasswordCtrl', ChangePasswordCtrl);

    ChangePasswordCtrl.$inject = ['$scope', '$modalInstance', 'config', 'AppConfigSvc'];

    /**
     * A controller for the change password dialog.  The injected config object (set via
     * resolve) is used to alter the dialog's behavior as follows.  If config.isAdmin is truthy, then
     * the password change is processed as if done by a privilege user that can does not have
     * to enter the existing password to change it.  If config.oldPassword is set, then that value
     * is prepopulated in the dialog.  In either of those cases, the old password text box is not
     * shown.
     *
     * Setting config.context to 'login' causes the dialog to display a warning if the browser window
     * is too narrow to properly use the web app.
     */
    function ChangePasswordCtrl($scope, $modalInstance, config, AppConfigSvc) {
        $scope.passwordChangeRequest = {};
        $scope.showPassword = false;
        $scope.agreeTerms = false;
        $scope.minLength = 8;
        $scope.isAdmin = config.isAdmin;

        if (config.oldPassword) {
            $scope.passwordChangeRequest = {
                oldPassword: config.oldPassword
            };
            $scope.prepopulated = true;
        }

        // let's define a variable loginContext if we are using the change password controller in a login context
        if (config.context && 'login' === config.context) {
            $scope.loginContext = true;
        }

        $scope.isFormAcceptable = function() {
            var isOldPasswordOk = $scope.isAdmin || $scope.passwordChangeRequest.oldPassword;
            var termsOk = !AppConfigSvc.isClinicApp() || $scope.agreeTerms;

            return termsOk && isOldPasswordOk
                    && $scope.satisfiesConfirmed()
                    && $scope.satisfiesMinLength()
                    && $scope.satisfiesUpperLetter()
                    && $scope.satisfiesLowerLetter()
                    && ($scope.satisfiesNumber() || $scope.satisfiesSymbol());
        };

        $scope.satisfiesMinLength = function() {
            return $scope.passwordChangeRequest.newPassword
                    && $scope.passwordChangeRequest.newPassword.length >= $scope.minLength;
        };

        $scope.satisfiesUpperLetter = function() {
            return $scope.passwordChangeRequest.newPassword && (/[A-Z]/).test($scope.passwordChangeRequest.newPassword);
        };

        $scope.satisfiesLowerLetter = function() {
            return $scope.passwordChangeRequest.newPassword
                    && (/[a-z]/).test($scope.passwordChangeRequest.newPassword);
        };

        $scope.satisfiesNumber = function() {
            return $scope.passwordChangeRequest.newPassword
                    && (/\d/).test($scope.passwordChangeRequest.newPassword);
        };

        $scope.satisfiesSymbol = function() {
            return angular.isDefined($scope.passwordChangeRequest.newPassword)
                    && (/[^a-zA-Z\d\s]/).test($scope.passwordChangeRequest.newPassword);
        };

        $scope.satisfiesConfirmed = function() {
            return $scope.showPassword
                    || $scope.passwordChangeRequest.newPassword === $scope.passwordChangeRequest.confirmPassword;
        };

        $scope.ok = function() {
            $modalInstance.close($scope.passwordChangeRequest);
        };

        $scope.cancel = function() {
            $modalInstance.dismiss('cancel');
        };

        /**
         * Returns whether this is the clinic web app.
         * @returns {Boolean} true if the current app is the clinic web app
         */
        $scope.isClinicApp = function() {
            return AppConfigSvc.isClinicApp();
        };
    }
})();